module.exports = __webpack_public_path__ + "ie.3214e5311a3de32e8376.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ie.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ie.svg
// module chunks = styles